<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";
import CommentsExample from "~/features/python/ch2/comments/components/CommentsExample.vue";
import CommentsPlayground from "~/features/python/ch2/comments/components/CommentsPlayground.vue";
import CommentsQuiz from "~/features/python/ch2/comments/components/CommentsQuiz.vue";
import { commentsContent } from "~/features/python/ch2/comments/data/comments.content";
import { buildComputerCollectionSchema } from "~/features/computer/data/seo/computer-schema";
import { pythonInteractiveCards } from "~/features/python/data/chapter2-interactive";

const relatedCards = pythonInteractiveCards.filter((item) => item.to !== "/11th/computer/python/comments/");

usePageSeo({
  title: "Chapter 2 Python Comments | Ustaad",
  description: "Chapter 2 Python comments page with examples, quick playground and comment quiz for class 11 students.",
  keywords: "chapter 2 python comments, python comments class 11, 11th class computer comments",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th Computer", item: "/11th/computer/" },
    { name: "Ch 2 Python", item: "/11th/computer/python/" },
    { name: "Comments", item: "/11th/computer/python/comments/" },
  ],
  schemaType: "CollectionPage",
  schemaProperties: buildComputerCollectionSchema({
    about: "Chapter 2 Python Comments",
    items: [
      { name: "Chapter 2 Python", path: "/11th/computer/python/" },
      { name: "Chapter 2 Python Variables", path: "/11th/computer/python/variables/" },
      { name: "Chapter 2 Python Functions", path: "/11th/computer/python/functions/" },
      { name: "Chapter 2 Python Programs", path: "/11th/computer/python/programs/" },
    ],
  }),
});
</script>

<template>
  <PageContainer>
    <div class="space-y-8">
      <section class="rounded-3xl bg-slate-950 p-6 text-white">
        <p class="text-xs font-semibold uppercase tracking-[0.18em] text-sky-300">Python Chapter 2</p>
        <h1 class="mt-2 text-2xl font-bold tracking-tight">Chapter 2 Python Comments</h1>
        <p class="mt-3 text-sm leading-7 text-slate-200">Comment woh chhoti note hoti hai jo coder apne liye likhta hai. Python ise padhta nahi, sirf insan padhta hai.</p>
      </section>

      <section class="rounded-3xl border border-slate-200 bg-white p-5">
        <div class="space-y-1">
          <h2 class="text-lg font-semibold text-slate-900">Comments kyun achay hote hain?</h2>
          <p class="text-sm text-slate-600">Syntax: <code>{{ commentsContent.syntax }}</code></p>
        </div>
        <div class="mt-4 grid gap-3 md:grid-cols-3">
          <article
            v-for="reason in commentsContent.reasons"
            :key="reason.title"
            class="rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200"
          >
            <h3 class="text-sm font-semibold text-slate-900">{{ reason.title }}</h3>
            <p class="mt-2 text-sm leading-6 text-slate-600">{{ reason.description }}</p>
          </article>
        </div>
      </section>

      <CommentsPlayground />
      <CommentsQuiz />

      <CommentsExample />

      <section class="rounded-3xl border border-slate-200 bg-slate-50 p-5">
        <div>
          <p class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">More Topics</p>
          <h2 class="mt-2 text-lg font-semibold text-slate-900">More Python Topics</h2>
        </div>
        <div class="mt-4 grid gap-3 md:grid-cols-3">
          <NuxtLink
            v-for="item in relatedCards"
            :key="item.to"
            :to="item.to"
            class="rounded-2xl border border-slate-200 bg-white p-4 transition hover:border-sky-300 hover:bg-sky-50"
          >
            <h3 class="text-sm font-semibold text-slate-900">{{ item.title }}</h3>
            <p class="mt-2 text-sm leading-6 text-slate-600">{{ item.description }}</p>
          </NuxtLink>
        </div>
      </section>
    </div>
  </PageContainer>
</template>
